module.exports = __webpack_public_path__ + "img/首页2-7.2387e2f8.svg";